// extracted by mini-css-extract-plugin
export default {"main":"Main_main__8i4DC","loading":"Main_loading__6KtRR","content":"Main_content__neS65","fadeIn":"Main_fadeIn__ck17h"};